import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class PolicyDiffService {
    static getPolicyDiffWithPrevious(data, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('policydiff'),
            'getPolicyDiffWithPrevious',
            [data],
            additionalHeaders
        );
    }
}
